import { Badge } from 'apps/dashboard/shared/scripts/components';

import { headingClassName, widgetHeaderClassName } from './styles';

interface Props {
  isPro?: boolean;
}

const WidgetHeader = ({ isPro }: Props) => {
  return (
    <div className={widgetHeaderClassName}>
      <h2 className={headingClassName}>Summary</h2>
      {isPro && <Badge label="Pro" />}
    </div>
  );
};

WidgetHeader.displayName = 'WidgetHeader';

export default WidgetHeader;
